export default "__VITE_ASSET__11506b33__"